const IssueTypeBarChart = (data = []) => {
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const item = params[0];
        return `<b>${item.name}</b><br/>Count: ${item.value}`;
      }
    },
    grid: {
      top: 20,
      bottom: 30,
      left: 0,
      right: 20,
      containLabel: true
    },
    xAxis: {
      type: 'value',
      name: 'Count',
      boundaryGap: [0, 0.01]
    },
    yAxis: {
      type: 'category',
      data: data.map(item => item.label),
      axisLabel: {
        formatter: (value) => value
      }
    },
    series: [
      {
        name: 'Issues',
        type: 'bar',
        data: data.map(item => ({
          value: item.count,
          name: item.label,
          itemStyle: {
            color: item.count === 0
              ? `${item.color}40` // Make it semi-transparent (placeholder)
              : item.color
          },
          label: {
            show: true,
            position: 'right',
            color: item.count === 0 ? '#aaa' : '#000',
            formatter: '{c}'
          }
        })),
        barCategoryGap: '30%',
        itemStyle: {
          borderRadius: [0, 4, 4, 0]
        }
      }
    ]
  };
};

export default IssueTypeBarChart;
